import * as svg from "../../../assets/add-icon.svg";

import {iconBuilder} from "./iconBuilder";

export const AddIcon = iconBuilder(svg, "AddIcon", "0 0 16 16");
